/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-constant-condition */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { useTranslate, useValidation } from '../../../../hooks';
import CustomModal from '../../CustomModal/CustomModal';
import ModalHeader from '../../CustomModal/ModalHeader';
import Compdirection from '../../../themes/CompDirection';
import { Button, CircularProgress, Grid } from '@mui/material';
import CustomAutoComplete from '../../../components/CustomAutoComplete/CustomAutoComplete';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import { FileInput, TextInput } from '../../../../components';
import ModalFooter from '../../CustomModal/ModalFooter';
import Loader from '../../../Lottifiers/Loader/Loader';
import { DropdownType } from '../../../../types';
import {
  useListLetterType,
  useCancel,
  useUpdateLetter,
  useViewOne,
} from '../../../../pages/letterGeneration/api';
import { useAppSelector } from '../../../../infra/hooks';

import './LetterViewModal.css';
import { createLetterValidations } from '../validations';

interface ModalInterface {
  isModalOpen: boolean;
  id?: string;
  closeModal: VoidFunction;
}

const LetterViewModalController = ({
  isModalOpen,
  id,
  closeModal,
}: ModalInterface) => {
  const companyId = useAppSelector((state) => state?.authSlice?.company_id);

  const [remarks, setRemarks] = useState('');
  const [addresTo, setAddresTo] = useState('');
  const [country, setCountry] = useState('');
  const [letterType, setLetterType] = useState<DropdownType | null>(null);
  const [language, setLanguage] = useState<DropdownType | null>(null);
  const [file, setFile] = useState<(File & { preview: string }) | null>(null);

  const [openCancelRequest, setOpenCancelRequest] = useState(false);

  const { translate } = useTranslate();

  const { data: letterTypes, isLoading: isFetchingLetterTypes } =
    useListLetterType({ params: {} });

  const { updateLetter, isUpdatingLetter } = useUpdateLetter(
    id!,
    translate('updated-successfully') || '',
  );
  const { cancel, isRejecting } = useCancel({
    id: id ?? '',
    msg: translate('cancel-successfully') || '',
  });

  const { isLoading, data } = useViewOne({
    id: id || '',
    options: {
      enabled: id ? true : false,
      onSuccess({ data }) {
        const result = data.data;

        setRemarks(result.remarks);
        setAddresTo(result.addressto);
        setCountry(result.countrydetails);
        setLetterType({
          id: result.letterType?.id,
          label: result.letterType?.title,
        });
        setFile(result.attachments[0]);
        setLanguage({
          id: result.language,
          label: result.language === 'en' ? 'English' : 'Arabic',
        });
      },
    },
  });

  const handleLetterType = (type: DropdownType) => {
    setLetterType(type);
  };

  const handleFile = (file: File & { preview: string }) => {
    setFile(file);
  };

  const closeConfirmationModal = () => {
    setOpenCancelRequest(false);
  };

  const { errors, validate } = useValidation(createLetterValidations, {
    letterType: letterType?.id,
    language: language?.id,
  });

  const onSubmit = async () => {
    if (await validate()) {
      const formData = new FormData();
      formData.append('companyId', companyId.toString());
      formData.append('letterType', letterType?.id?.toString()!);
      formData.append('language', language?.id?.toString()!);

      if (remarks) {
        formData.append('remarks', remarks);
      }
      if (addresTo) {
        formData.append('addressto', addresTo);
      }
      if (country) {
        formData.append('countrydetails', country);
      }
      if (file && typeof file !== 'string') {
        formData.append('attachments[]', file!);
      }

      if (!file) {
        formData.append('attachmentsRemoved', '1');
      }

      updateLetter(formData, {
        onSuccess() {
          closeModal();
        },
      });
    }
  };

  return (
    <>
      <CustomModal
        isModalOpen={isModalOpen}
        modalHeight="755px"
        modalWidth="600px"
      >
        <ModalHeader
          modal={{ modal_title: translate('Edit Letter') || '' }}
          closeModal={closeModal}
        />
        <div>
          <Compdirection>
            <Grid
              container
              spacing={2}
              style={{
                marginTop: '5px',
              }}
            >
              {!isLoading ? (
                <>
                  <Grid item xs={12}>
                    <TextInput
                      label={translate('Reference Id')}
                      name=""
                      className="mb-1"
                      defaultValue={data?.referenceId}
                      disabled={true}
                    />
                    <CustomAutoComplete
                      label={translate('Letter Type') || ''}
                      options={letterTypes?.map((letterType: any) => ({
                        id: letterType.id,
                        label: letterType.title,
                      }))}
                      value={letterType}
                      errors={errors['letterType']}
                      isLoading={isFetchingLetterTypes}
                      onChange={(event: any, newValue: any) => {
                        handleLetterType(newValue);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <CustomAutoComplete
                      label={translate('language') || ''}
                      options={[
                        {
                          label: 'English',
                          id: 'en',
                        },
                        {
                          label: 'Arabic',
                          id: 'ar',
                        },
                      ]}
                      value={language}
                      errors={errors['language']}
                      onChange={(event: any, newValue: any) => {
                        setLanguage(newValue);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <CustomTextField
                      type="string"
                      label={translate('Reason') || ''}
                      placeholder={translate('Write Reason') || ''}
                      value={remarks}
                      multiline
                      onChange={(e: any) => setRemarks(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <CustomTextField
                      type="string"
                      label={translate('Address to') || ''}
                      placeholder={translate('Write Address to') || ''}
                      value={addresTo}
                      multiline
                      onChange={(e: any) => setAddresTo(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <CustomTextField
                      type="string"
                      label={translate('Emirates / Country') || ''}
                      placeholder={translate('Write Emirates / Country') || ''}
                      value={country}
                      multiline
                      onChange={(e: any) => setCountry(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FileInput
                      files={file}
                      handleFiles={handleFile}
                      handleDownload={() => {
                        const link = document.createElement('a');
                        if (file) {
                          link.href = file as unknown as string;
                          link.download = `${letterType?.label}.pdf`;
                          link.target = '_blank';
                          link.click();
                        }
                      }}
                      name="attachment"
                    />
                  </Grid>
                </>
              ) : (
                <Loader />
              )}
            </Grid>
          </Compdirection>

          <ModalFooter
            isSubmitting={isUpdatingLetter}
            title_for_submit_btn="Update"
            onClickSubmit={onSubmit}
            onClickCancel={() => {
              closeModal();
            }}
          >
            <Button
              className={`mx-1 ${
                isRejecting ? 'disabled-btn' : 'cancel-request-btn'
              }`}
              onClick={() => {
                setOpenCancelRequest(true);
              }}
            >
              {translate('cancel-request')}

              {isRejecting ? (
                <CircularProgress
                  style={{
                    width: '16px',
                    height: '16px',
                    color: 'gray',
                    margin: '0 10px',
                  }}
                />
              ) : null}
            </Button>
          </ModalFooter>
        </div>
      </CustomModal>

      {openCancelRequest ? (
        <CustomModal
          isModalOpen={openCancelRequest}
          modalHeight="755px"
          modalWidth="600px"
        >
          <p>{translate('confirm-cancellation')}</p>
          <ModalFooter
            title_for_submit_btn={translate('Confirm') || ''}
            onClickSubmit={() => {
              closeConfirmationModal();

              cancel(
                {},
                {
                  onSuccess: () => {
                    closeModal();
                  },
                },
              );
            }}
            onClickCancel={() => {
              closeConfirmationModal();
            }}
          ></ModalFooter>
        </CustomModal>
      ) : null}
    </>
  );
};

export default LetterViewModalController;
